import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { AddToCampaignDialogComponent } from '../../actions/add-to-campaign-dialog.component';
import { UserListsColumnComponent } from './user-lists-column.component';

@Component({
  template: `
    <div class="user-list-action-column">
      <a (click)="openCampaignScheduler()">{{ 'LISTS.USER_LIST.ADD_TO_CAMPAIGN' | translate }}</a>
    </div>
  `,
  styleUrls: ['../user-lists-overview.component.scss'],
})
export class UserListActionColumnComponent extends UserListsColumnComponent {
  constructor(
    private dialog: MatDialog,
    private snackbarService: SnackbarService,
    private translate: TranslateService,
  ) {
    super();
  }

  openCampaignScheduler(): void {
    const dialogRef = this.dialog.open(AddToCampaignDialogComponent, {
      width: '660px',
    });
    dialogRef.componentInstance.userList = this.element;
    dialogRef.afterClosed().subscribe({
      error: () => {
        this.snackbarService.openWithOptions('LISTS.CAMPAIGN_DIALOG.CAMPAIGN_AVOIDED', {
          interpolateTranslateParams: {
            name: this.element.userListName,
          },
        });
      },
    });
  }
}
